import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import OtpInput from 'react-otp-input'
const PopupOtp = (props) => {
  const { otp, isErrorOTP, handleChangeOTP, closeModalOTP, handleResendOTP } = props
  const navigate = useNavigate()
  const [config, setConfig] = useState({
    numInputs: 6,
    otpValue: '',
    separator: '',
    regex: /^([0-9]{0,})$/,
    isDisabled: false,
    isInputNum: true,
    hasErrored: false,
  })
  const TIME_OUT = 90
  const [seconds, setSeconds] = useState(TIME_OUT - 1)
  const [numberResendOTPTime, setNumberResendOTPTime] = useState(0)
  const intervalRef = useRef(null)
  useEffect(() => {
    countTime()
    return () => clearTime()
  }, [])

  useEffect(() => {
    if(isErrorOTP) {
      const listInput = document.querySelectorAll(".otp-field__input")
      listInput.forEach(element => {
        element.classList.add('error')
      })
    } else {
      const listInput = document.querySelectorAll(".otp-field__input")
      listInput.forEach(element => {
        element.classList.remove('error')
      })
    }
  }, [isErrorOTP])

  const countTime = () => {
    intervalRef.current = setInterval(() => {
      setSeconds((second) => {
        if (second < 1) {
          clearTime()
          if (numberResendOTPTime < 2) {
            const el = document.querySelector('#resend_otp')
            el.classList.remove('disabled')
          }
          // handleButton("#submit_otp", true);
          return 0
        }
        return second - 1
      })
    }, 1000)
  }
  const clearTime = () => {
    clearInterval(intervalRef.current)
  }
  const onChangeOTP = (value) => {
    if (seconds === 0) return
    handleChangeOTP(value)
  }
  const onCloseModal = () => {
    props.closeModalOTP()
    navigate('/')
  }
  const onResendOTP = () => {
    if (numberResendOTPTime < 3) {
      const el = document.querySelector('#resend_otp')
      el.classList.add('disabled')
      setSeconds(TIME_OUT)
      handleResendOTP()
      countTime()
      setNumberResendOTPTime(numberResendOTPTime + 1)
    }
  }

  return (
    <>
      <div className="popup-overlay modal-notify">
        <div className="popup-warp">
          {/* <div className="icon-popup"></div> <div className="close-modal" ></div> */}
          <div className="popup-inner">
            <div className="icon-popup"></div>
            <div className="content-popup">
              <form className="login-otp">
                <h3>Nhập mã OTP</h3>
                <div className="form-group">
                  <OtpInput
                    value={otp}
                    onChange={onChangeOTP}
                    numInputs={Number(config.numInputs)}
                    // shouldAutoFocus
                    inputType="number"
                    separator={<span>{config.separator}</span>}
                    isInputNum={config.isInputNum}
                    hasErrored={isErrorOTP}
                    inputStyle={'otp-field__input'}
                    containerStyle={'otp-field'}
                    renderInput={(props) => <input {...props} placeholder={'-'} disabled={seconds === 0} />}
                  />
                </div>

                <div className="note-login">
                  <div className="ionic-label-center error">
                    <div className="text-red" style={{ whiteSpace: 'pre-line' }}>
                      {seconds === 0
                        ? `Mã xác thực đã hết hạn.\nVui lòng gửi lại mã mới và thử lại`
                        : props.isErrorOTP && 'Mã xác thực chưa chính xác.\nVui lòng kiểm tra lại thông tin.'}
                    </div>
                  </div>
                </div>

                {/* {props.isErrorOTP && (
                  <div className="note-login">
                    <div className="ionic-label-center error">
                      <div className="text-red">
                        Mã OTP chưa chính xác. Vui lòng kiểm tra lại.
                      </div>
                    </div>
                  </div>
                )}

                {seconds === 0 && (
                   <div className="note-login">
                   <div className="ionic-label-center error">
                     <div className="text-red">
                       Mã OTP đã hết hiệu lực. Vui lòng kiểm tra lại.
                     </div>
                   </div>
                 </div>
                )} */}

                <p className="note-login" id="description-otp">
                  Mã OTP sẽ hết hiệu lực trong
                  <span className="text-red" id="count-down-time">
                    {' '}
                    {seconds} giây
                  </span>
                </p>

                <div className="group-btn-inline">
                  <button id="submit_otp" type="button" className="btn btn-primary btn-border btn-block" onClick={onCloseModal}>
                    Đóng
                  </button>
                  <button id="resend_otp" type="button" className="btn btn-primary disabled btn-block " onClick={onResendOTP}>
                    GỬI LẠI OTP
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default PopupOtp
